var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelfHandledActive1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "78px",
    viewBox: "0 0 44 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Self_Handled_Active_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.034,0.229810119 C4.88453478,0.0826830181 4.68161411,0 4.47,0 C4.25838589,0 4.05546522,0.0826830181 3.906,0.229810119 L0.234,3.83623869 C-0.078,4.14266726 -0.078,4.63766726 0.234,4.94409583 L3.906,8.5505244 C4.218,8.85695298 4.722,8.85695298 5.034,8.5505244 C5.346,8.24409583 5.346,7.74909583 5.034,7.44266726 L1.93,4.38623869 L5.034,1.33766726 C5.346,1.03123869 5.338,0.528381547 5.034,0.229810119 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.234,0.230813138 C-0.078,0.537241709 -0.078,1.03224171 0.234,1.33867028 L3.338,4.38724171 L0.234,7.43581314 C-0.078,7.74224171 -0.078,8.23724171 0.234,8.54367028 C0.546,8.85009885 1.05,8.85009885 1.362,8.54367028 L5.034,4.93724171 C5.346,4.63081314 5.346,4.13581314 5.034,3.82938457 L1.362,0.222955995 C1.058,-0.0756154334 0.546,-0.0756154334 0.234,0.230813138 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Self_Handled_Active_1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#BFCFDA",
    fill: "#E5E9F4",
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 77,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#BFCFDA",
    fill: "#FFFFFF",
    x: 5.5,
    y: 11.5,
    width: 34,
    height: 49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#BFCFDA",
    fill: "#FFFFFF",
    cx: 22.5,
    cy: 70.5,
    r: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#63A5E8",
    x: 9,
    y: 28,
    width: 27,
    height: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrows",
    transform: "translate(16.366, 32.1098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation/chevron_left_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/chevron_left_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Fill",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.966, -5.0384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.2,
    height: 18.8571429
  })))), /*#__PURE__*/React.createElement("g", {
    id: "navigation/chevron_right_24px",
    transform: "translate(8, 0.0034)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/chevron_right_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Fill",
    mask: "url(#mask-4)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.966, -5.0418)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.2,
    height: 18.8571429
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfHandledActive1);
export default __webpack_public_path__ + "static/media/Self_Handled_Active_1.c583e6b16a39ab85802f132003144bfe.svg";
export { ForwardRef as ReactComponent };